import React, { FC, useMemo } from 'react'
import { ArticleHeadlineProps } from '@sport1/types/web'
import Font from '@sport1/news-styleguide/Font'
import { useRouter } from 'next/router'
import { sport1Bold } from '@/helpers/fonts'
import useIsOnlineCasino from '@/hooks/useIsOnlineCasino'

type props = {
    content: ArticleHeadlineProps
}
const ArticleHeadline: FC<props> = ({ content }) => {
    const { asPath } = useRouter()
    const isOnlineCasino = useIsOnlineCasino()
    const webHeadlineType = useMemo(() => {
        if (asPath?.includes('/sportwetten/') || isOnlineCasino) {
            return 'h1'
        }
        return 'h2'
    }, [isOnlineCasino, asPath])

    return (
        <Font
            webHeadlineType={webHeadlineType}
            fontVariant={['Headline-M', 'Headline-M', 'Display-L']}
            fontFamilyVariant="Sport1-Bold-Headline"
            nextFontFamilyVariant={sport1Bold.style.fontFamily}
            marginBottom="spacing-9"
            testID="article-headline"
        >
            {content.text}
        </Font>
    )
}

export default ArticleHeadline
